<script>
    export default {
        props: {
            data: Object,
            updateData: Function,
        },
    }
</script>

<template>
    <div class="left_sub_panel_data">
        <label>Search String:</label>
        <textarea
            :value="data['search_string']"
            @change="updateData($event, 'search_string')"
            class="right_input mt_5"
        ></textarea>
    </div>
</template>